<div class="container-fluid example">
<div>
<div  class="row" style="border-bottom: 1px solid #e9e9e8; margin: 0px 0px 10px 10px;">
  <div class="col-md-12 col-lg-12 col-xl-lg">
    <div class="row">
      <div class="col-md-2 col-lg-2 col-xl-2">
        <p class="System-text">Email Configuration</p>
      </div>
    </div>
  </div>
</div>
<div class="col-md-8 col-xl-8">
<form #editEmailForm="ngForm">


  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>SMTP Port</label>
    </div>
    <div class="col-md-5 col-xl-5">
     <input type="text" class="form-control"  [(ngModel)]="SettingsDetails.SMTPPort" name="SmtpPort" id="SmtpPort"
     #SmtpPort="ngModel" required />
    </div>
  </div>

  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>SMTP host</label>
    </div>
    <div class="col-md-5 col-xl-5">
      <input type="text" class="form-control"  [(ngModel)]="SettingsDetails.SMTPHost" name="Smtphost" id="Smtphost"
      #Smtphost="ngModel" required />
      <!-- <div *ngIf="Smtphost.invalid && (Smtphost.dirty || Smtphost.touched)" class="alert alert-danger">
        <div *ngIf="Smtphost.errors.required">
          SMTP host is required.
        </div>
      </div> -->
    </div>
  </div>

  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>Enable email notification</label>
    </div>
    <div class="col-md-5 col-xl-5">   
    <input type="checkbox" [checked]="EnableEmail" [(ngModel)]="SettingsDetails.EnableEmailNotification"  name="enableEmailNotification" id="enableEmailNotification" #enableEmailNotification="ngModel" required> 
    </div>
  </div>

  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>Notification email from</label>
    </div>
    <div class="col-md-5 col-xl-5">
      <input type="text" class="form-control"  [(ngModel)]="SettingsDetails.EmailNotificationFrom"
      name="notifyEmail" id="notifyEmail" #notifyEmail="ngModel" required/> 
      <!-- <div *ngIf="notifyEmail.invalid && (notifyEmail.dirty || notifyEmail.touched)" class="alert alert-danger">
        <div *ngIf="notifyEmail.errors.required">
          Notification email from is required.
        </div>
      </div> -->
    </div> 
  </div>


  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>Email delivery attempts</label>
    </div>
    <div class="col-md-5 col-xl-5">
      <input type="text" class="form-control" class="form-control" [(ngModel)]="SettingsDetails.EmailDeliveryAttempts"
      name="delvrEmail" id="delvrEmail" #delvrEmail="ngModel" required/>


      <!-- <div *ngIf="delvrEmail.invalid && (delvrEmail.dirty || delvrEmail.touched)" class="alert alert-danger">
        <div *ngIf="delvrEmail.errors.required">
          Email delivery attempts is required.
        </div>
      </div> -->
    </div>
    <div class="col-md-3 col-xl-4 pt-2 pl-0">
      <!-- <span isEllipsisActive class="px-2">
        <i [popover]="attempts" triggers="mouseenter:mouseleave" class="icon-ic_info">
        </i>
        <ng-container>
          <ng-template #attempts>
            <span>Number of notifications to be sent before raising a ticket
            </span>
          </ng-template>
        </ng-container>
      </span>
    </div> -->
  </div>

 
</div>

  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>Default Email Subject for TSS Notification Email</label>
    </div>
    <div class="col-md-5 col-xl-5">
      <input type="text" class="form-control"  [(ngModel)]="SettingsDetails.DefaultEmailSubjectforTSS"
      name="defltEmail" id="defltEmail" #defltEmail="ngModel" required />
      <!-- <div *ngIf="defltEmail.invalid && (defltEmail.dirty || defltEmail.touched)" class="alert alert-danger">
        <div *ngIf="defltEmail.errors.required">
          Default Email Subject for TSS Notification Email is required.
        </div>
      </div> -->
    </div>
  </div>


  <div class="row" style="padding-bottom: 15px;">
    <div class="col-md-3 col-xl-3 pb-2">
      <label>Default Email Subject for Summary Email</label>
    </div>
    <div class="col-md-5 col-xl-5">
      <input type="text" class="form-control" [(ngModel)]="SettingsDetails.DefaultEmailSubjectforSummary"
      name="defltEmailSumry" id="defltEmailSumry" #defltEmailSumry="ngModel" required />
      <!-- <div *ngIf="defltEmailSumry.invalid && (defltEmailSumry.dirty || defltEmailSumry.touched)"
        class="alert alert-danger">
        <div *ngIf="defltEmailSumry.errors.required">
          Default Email Subject for Summary Email is required.
        </div>
      </div> -->
    </div>
  </div>
</form>
</div>
</div>
</div>

<div style="margin-left: 46%;margin-bottom: 13px; margin-top: 10px;">
    <button class="btn btn-sm btn-secondary mx-2" >
      Cancel
    </button>
    <button class="btn btn-sm btn-primary mx-2" 
      type="submit" (click)="onSubmit(editEmailForm)">
      Save
    </button> 
  </div>